import { IconCheck, IconPlus, IconToggleLeft, IconToggleRight, IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi, postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import Layout from '../../layout/Layout';

const UpdateSetting = () => {

    const { settingId } = useParams();
    const [settingData, setSettingData] = useState(null);
    const [addDomainView, setAddDomainView] = useState(false);

    const fetchSettingData = async () => {
        const resp = await getApi(`${urlApi.getSettingDetails}${settingId}`);
        if (resp.responseCode === 200) {
            setSettingData(resp.data);
        } else {
            setSettingData(null);
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        fetchSettingData()
    }, [settingId]);

    const updateRewardRate = async () => {
        let rewardRateData = {
            settingId: settingData?._id,
            rewardRate: document.getElementById('reward-rate').value?.trim(),
        }
        let resp = await postApi(rewardRateData, urlApi.updateRewardRate);
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            fetchSettingData();
        } else {
            toast.error(resp.message);
        }
    }

    const updateMinRewardAmount = async () => {
        let minRewardAmountData = {
            settingId: settingData?._id,
            minWithdrawForReward: document.getElementById('min-withdraw-for-reward').value?.trim(),
        }
        let resp = await postApi(minRewardAmountData, urlApi.updateMinWithdrawValue);
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            fetchSettingData();
        } else {
            toast.error(resp.message);
        }
    }

    const handleAddDomain = async () => {
        if (document.getElementById('domain-new').value) {
            let domainData = {
                settingId: settingData?._id,
                domain: document.getElementById('domain-new').value?.trim(),
            }
            let resp = await postApi(domainData, urlApi.addShortLinkDomain);
            if (resp.responseCode === 200) {
                toast.success(resp.message);
                document.getElementById('domain-new').value = '';
                fetchSettingData();
            } else {
                toast.error(resp.message);
            }
        }
    }

    const updateDomainStatus = async (domainId, status) => {
        let domainData = {
            settingId: settingData?._id,
            domainId: domainId,
            updateValue: status,
        }
        let resp = await postApi(domainData, urlApi.updateShortLinkDomainStatus);
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            fetchSettingData();
        } else {
            toast.error(resp.message);
        }
    }

    const updateRewardShowStatus = async (status) => {
        let rewardShowStatusData = {
            settingId: settingData?._id,
            updateValue: status,
        }
        let resp = await postApi(rewardShowStatusData, urlApi.updateRewardShowStatus);
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            fetchSettingData();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <Layout>
            <div className='flex items-center mb-3 justify-between'>
                <h1 className='text-xl font-bold text-gray-600'>Update Settings</h1>
            </div>

            <div className="grid grid-cols-2 !gap-4">
                <div className="flex flex-col gap-1 col-span-1 shadow !p-3 rounded-lg">
                    <label htmlFor="reward-rate" className='font-medium'>Reward Rate</label>
                    <input type="text" id='reward-rate' placeholder="Reward Rate" defaultValue={settingData?.rewardRate} className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' />
                    <div className="text-end">
                        <ConfirmationModal
                            buttonComponent={<button className='bg-primary !px-5 !py-1.5 rounded-full text-sm text-white'>Update</button>}
                            confirmationText={"Are You Sure Want To Update?"}
                            onConfirm={() => updateRewardRate()} />
                    </div>
                </div>

                <div className="flex flex-col gap-1 col-span-1 shadow !p-3 rounded-lg">
                    <label htmlFor="min-withdraw-for-reward" className='font-medium'>Minimum Amount Need For Withdraw Reward</label>
                    <input type="text" id='min-withdraw-for-reward' placeholder="Minimum amount for withdraw" defaultValue={settingData?.minWithdrawForReward} className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' />
                    <div className="text-end">
                        <ConfirmationModal
                            buttonComponent={<button className='bg-primary !px-5 !py-1.5 rounded-full text-sm text-white'>Update</button>} confirmationText={"Are You Sure Want To Update?"}
                            onConfirm={() => updateMinRewardAmount()} />
                    </div>
                </div>


                <div className="flex flex-col gap-1 col-span-1 shadow !p-3 rounded-lg">
                    <label htmlFor="" className='font-medium'>Short Link Domains</label>
                    {
                        settingData?.shortLinkDomain?.map((item, index) => {
                            return (
                                <div className='flex gap-3 mb-1' key={index}>
                                    <input type="text" id={'domain-' + item?._id} placeholder="Domain" defaultValue={item?.domain} className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)] w-full' />
                                    <ConfirmationModal
                                        buttonComponent={<button>{item?.status == 1 ? <IconButton icon={<IconToggleRight color='green' />} /> : <IconButton icon={<IconToggleLeft color='red' />} />}</button>}
                                        confirmationText={`Are You Sure Want To ${item?.status == 1 ? 'Deactivate' : "Activate"} this Domain ?`}
                                        onConfirm={() => updateDomainStatus(item?._id, item?.status == 1 ? 2 : 1)}
                                    />
                                </div>
                            )
                        })
                    }

                    {
                        addDomainView && (
                            <div className='flex gap-3 mb-1' >
                                <input type="text" id={'domain-new'} placeholder="Domain" className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)] w-full' />
                                <ConfirmationModal buttonComponent={<IconButton icon={<IconCheck color='green' />} />} confirmationText={"Are you sure want to add this domain?"} onConfirm={() => handleAddDomain()} />
                                <IconButton icon={<IconX color='red' />} onClickFunction={() => setAddDomainView(false)} />
                            </div>
                        )
                    }

                    {!addDomainView && <div className="text-end mb-2">
                        <IconButton cssClass={'text-sm text-white ms-auto'} icon={<IconPlus color='blue' size={18} />} onClickFunction={() => setAddDomainView(true)} />
                    </div>}
                </div>

                {settingData?.rewardShowStatus && <div className="flex flex-col gap-2 col-span-1 shadow !p-3 rounded-lg justify-center items-center">
                    <label htmlFor="min-withdraw-for-reward" className='font-medium'>Reward Show Status</label>
                    <ConfirmationModal
                        buttonComponent={<button className='shadow-md'>{settingData?.rewardShowStatus == 1 ? <IconButton icon={<IconToggleRight color='green' />} /> : <IconButton icon={<IconToggleLeft color='red' />} />}</button>}
                        confirmationText={`Are You Sure Want To ${settingData?.rewardShowStatus == 1 ? 'Deactivate' : "Activate"} Reward Show Status ?`}
                        onConfirm={() => updateRewardShowStatus(settingData?.rewardShowStatus == 1 ? 2 : 1)}
                    />
                </div>}
            </div>

        </Layout>
    )
}

export default UpdateSetting